import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Book from "../components/ui/Book";
import Rating from "../components/ui/Rating";
import Price from "../components/ui/Price";

export default function BookInfo({ books, addToCart, cart }) {
  const { id } = useParams();
  const book = books.find((book) => +book.id === +id);

  function addBookToCart(book) {
    addToCart(book);
  }

  function isBookInCart() {
    return cart.find((book) => +book.id === +id);
  }

  return (
    <div id="books__body">
      <main id="books__main">
        <div className="books__container">
          <div className="row">
            <div className="book__selected--top">
              <Link to="/books" className="book__link">
                <FontAwesomeIcon icon="arrow-left" />
              </Link>
              <Link to="/books" className="book__link">
                <h2 className="book__selected--title--top">Books</h2>
              </Link>
            </div>
            <div className="book__selected">
              <figure className="book__selected--figure">
                <img
                  src={book.url}
                  alt="selected book image"
                  className="book__selected--img"
                />
              </figure>
              <div className="book__selected--description">
                <h2 className="book__selected--title">{book.title}</h2>
                <Rating rating={book.rating} />
                <div className="book__price">
                  <Price
                    salePrice={book.salePrice}
                    originalPrice={book.originalPrice}
                    displayMode='and'
                  />
                </div>
                <div className="book__summary">
                  <h3 className="book__summary--title">Summary</h3>
                  <p className="book__summary--para">
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Aliquam magnam animi, voluptate inventore, optio illo ab
                    dicta quia vitae earum nulla eos deleniti error debitis
                    illum alias voluptatum modi eveniet.
                  </p>
                  <p className="book__summary--para">
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                    Dolores nihil, reiciendis dolor sit similique esse sunt
                    facilis corrupti incidunt officia aperiam voluptas quos
                    assumenda, molestias soluta maxime harum, cupiditate
                    debitis.
                  </p>
                </div>
                {isBookInCart() ? (
                  <Link to="/cart">
                    <button className="btn">Checkout</button>
                  </Link>
                ) : (
                  <button onClick={() => addBookToCart(book)} className="btn">
                    Add To Cart
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="books__container">
          <div className="row">
            <div className="book__selected--top">
              <h2 className="book__selected--title">Recommended Books</h2>
            </div>
            <div className="books">
              {books
                .filter((book) => +book.id !== +id && book.rating === 5)
                .slice(0, 4)
                .map((book) => (
                  <Book key={book.id} book={book} />
                ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
